import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twozeroseatertempo() {

const cardData = {
keyword: "20 Seater Tempo Traveller On Rent in Pune",
headingDescription: "Ruturaj Enterprises provides 20 Seater Tempo Traveller On Rent in Pune for families, friends, corporate teams, wedding groups, school excursions, airport transfers, picnics, sightseeing programs, and planned tourist journeys. A 20-seater Tempo Traveller is a practical choice for medium-sized groups that want to travel together instead of arranging several separate cars, offering coordinated transportation with comfortable seating and convenient luggage space. Rental arrangements can be planned for one-day trips, weekend getaways, multi-day tours, corporate travel, marriage functions, and longer journeys from Pune to destinations across Maharashtra and nearby states. Depending on the travel requirement, customers can select suitable AC, luxury, or budget-friendly options according to passenger needs, destination, trip duration, and itinerary.",
topPlaces: [
{
title: "Bhimashankar",
description: "Bhimashankar is a popular destination for family outings, pilgrimage journeys, nature trips, and group excursions from Pune. A 20-seater Tempo Traveller allows a medium-sized group to travel together comfortably while keeping passengers, luggage, and the planned itinerary organized throughout the journey."
},
{
title: "Goa",
description: "Goa is suitable for friends, families, corporate groups, and tourist parties planning an extended road trip from Pune. A 20-seater Tempo Traveller provides a convenient shared vehicle for longer travel, allowing the group to manage luggage, sightseeing plans, scheduled stops, and return travel without coordinating several separate cars."
},
{
title: "Shirdi",
description: "Shirdi attracts families, religious groups, senior travelers, and organized tour parties throughout the year. Hiring a 20-seater Tempo Traveller from Pune provides a practical group transportation arrangement with shared seating and luggage space, making the journey easier to coordinate from departure through the return trip."
},
{
title: "Dapoli",
description: "Dapoli offers a scenic coastal getaway for families, friends, school groups, and corporate teams traveling from Pune. A 20-seater vehicle is well suited for medium-sized groups because everyone can remain together while enjoying a coordinated route, convenient luggage accommodation, and planned sightseeing during the trip."
},
{
title: "Nashik",
description: "Nashik is a versatile destination for family holidays, religious visits, corporate programs, and organized group tours from Pune. A 20-seater Tempo Traveller makes group transportation easier by providing one shared vehicle for passengers and luggage while supporting a common schedule for sightseeing and return travel."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill destination for weekend holidays, family trips, school excursions, and corporate outings from Pune. The 20-seater Tempo Traveller offers a convenient option for medium-sized groups traveling together, with practical seating and luggage arrangements for the complete road journey."
},
{
title: "Ratnagiri",
description: "Ratnagiri is suitable for coastal holidays, family tours, educational journeys, and multi-day group travel from Pune. A dedicated 20-seater Tempo Traveller can help passengers stay together on the longer route while making it easier to organize luggage, sightseeing stops, accommodation transfers, and the scheduled return journey."
},
{
title: "Panchgani",
description: "Panchgani provides a scenic setting for family vacations, student excursions, corporate outings, and short group tours from Pune. A 20-seater Tempo Traveller offers shared transportation for the group, helping organizers coordinate departure timings, destination visits, meal stops, and return travel through one vehicle."
},
{
title: "Alibaug",
description: "Alibaug is a convenient destination for weekend trips, family outings, friend groups, and corporate recreation programs from Pune. With a 20-seater Tempo Traveller, passengers can travel together with their belongings while maintaining a common itinerary and avoiding the coordination challenges of multiple individual vehicles."
},
{
title: "Tuljapur",
description: "Tuljapur is a suitable destination for family pilgrimages, religious tours, and organized group journeys from Pune. A 20-seater Tempo Traveller provides a comfortable shared transportation option for medium-sized groups, allowing passengers to coordinate departure, temple visits, meal breaks, and return travel more conveniently."
}
],
services: [
{
name: "20 Seater Tempo Traveller Rental Pune",
description: "20 Seater Tempo Traveller Rental Pune is suitable for medium-sized families, friends, corporate teams, wedding groups, school parties, and organized tourist groups requiring one dedicated vehicle. Ruturaj Enterprises can arrange the rental around passenger count, destination, travel duration, luggage requirements, and the complete itinerary for a convenient group journey."
},
{
name: "20 Seater Tempo Traveller Hire Pune",
description: "20 Seater Tempo Traveller Hire Pune provides a shared transportation solution for groups that want to stay together throughout their journey. The vehicle can be considered for family holidays, corporate programs, weddings, school excursions, picnics, sightseeing trips, and outstation travel with schedules planned according to the group's requirements."
},
{
name: "20 Seater Tempo Traveller Booking Pune",
description: "20 Seater Tempo Traveller Booking Pune helps groups organize their vehicle requirements in advance according to the planned route, passenger count, travel dates, and journey duration. Advance coordination can make it easier to arrange pickup points, departure timings, luggage needs, sightseeing stops, overnight stays, and return transportation."
},
{
name: "20 Seater AC Tempo Traveller Pune",
description: "20 Seater AC Tempo Traveller Pune offers a comfortable group transportation option for passengers who prefer an air-conditioned cabin during their journey. It can be suitable for family vacations, corporate travel, weddings, tourist tours, airport transfers, and longer highway trips where passengers may spend several hours traveling together."
},
{
name: "20 Seater Luxury Tempo Traveller Pune",
description: "20 Seater Luxury Tempo Traveller Pune is designed for groups looking for a more comfortable and refined travel arrangement for special occasions and extended journeys. It can be considered for premium family tours, corporate events, wedding transportation, executive group travel, and tourist programs where enhanced passenger comfort is an important requirement."
},
{
name: "20 Seater Traveller for Outstation Pune",
description: "20 Seater Traveller for Outstation Pune provides a dedicated group vehicle for journeys from Pune to destinations across Maharashtra and nearby states. Medium-sized groups can travel together while keeping luggage, passenger coordination, sightseeing schedules, planned stops, and return arrangements within one organized transportation setup."
},
{
name: "20 Seater Traveller for Family Trip Pune",
description: "20 Seater Traveller for Family Trip Pune is suitable for families planning holidays, pilgrimages, weekend breaks, and multi-day tours with relatives traveling together. The spacious group arrangement helps keep adults, children, and senior family members together while providing convenient seating and room for the belongings needed during the journey."
},
{
name: "20 Seater Traveller for Group Travel Pune",
description: "20 Seater Traveller for Group Travel Pune is a practical option for friends, relatives, social groups, and organized travel parties that need shared transportation. One suitable vehicle can simplify route coordination, passenger management, luggage handling, sightseeing schedules, and return travel compared with arranging several separate cars."
},
{
name: "20 Seater Traveller for Corporate Events Pune",
description: "20 Seater Traveller for Corporate Events Pune supports employee transportation for conferences, meetings, training programs, team outings, company celebrations, and corporate gatherings. A dedicated vehicle allows participants to travel together according to planned pickup locations and event timings while providing a coordinated arrangement for venue transfers and return journeys."
},
{
name: "20 Seater Traveller for Wedding Pune",
description: "20 Seater Traveller for Wedding Pune is useful for transporting relatives, guests, friends, and wedding groups between homes, hotels, ceremony venues, and other scheduled locations. The dedicated vehicle can help families coordinate passenger movement around wedding functions while keeping the group together during local or outstation travel."
},
{
name: "20 Seater Traveller for School Trip Pune",
description: "20 Seater Traveller for School Trip Pune can be arranged for educational tours, excursions, field visits, recreational outings, and student group travel. A dedicated vehicle helps teachers and organizers coordinate students around the planned itinerary, including departure points, destination visits, scheduled breaks, sightseeing activities, and return timings."
},
{
name: "20 Seater Traveller for Airport Pickup Pune",
description: "20 Seater Traveller for Airport Pickup Pune provides group transportation for passengers arriving together at Pune Airport or traveling collectively for an onward journey. The vehicle offers a convenient arrangement for multiple travelers and their luggage while supporting scheduled pickup coordination and direct transfers to hotels, residences, offices, or other destinations."
},
{
name: "Affordable 20 Seater Tempo Traveller Pune",
description: "Affordable 20 Seater Tempo Traveller Pune is intended for groups looking for practical transportation while keeping the overall journey budget under consideration. Rental planning can be aligned with group size, destination, trip duration, and vehicle requirements so passengers can use one shared vehicle instead of arranging multiple separate cars."
},
{
name: "20 Seater Traveller Rental Service Pune",
description: "20 Seater Traveller Rental Service Pune provides group transportation for family tours, corporate travel, weddings, school trips, tourist programs, picnics, airport transfers, and outstation journeys. The rental can be coordinated around the complete itinerary, including pickup locations, travel timings, destination stops, overnight requirements, and scheduled return."
},
{
name: "20 Seater Traveller for Picnic Pune",
description: "20 Seater Traveller for Picnic Pune is suitable for families, friends, colleges, offices, and social groups planning recreational outings together. A dedicated vehicle gives passengers a shared travel arrangement for reaching the picnic destination while providing convenient seating and space for personal belongings, food items, and other trip essentials."
},
{
name: "20 Seater Traveller for Local Sightseeing Pune",
description: "20 Seater Traveller for Local Sightseeing Pune can support medium-sized groups visiting multiple attractions during a planned sightseeing program around Pune and nearby travel circuits. One group vehicle makes it easier to coordinate passenger movement, sightseeing stops, luggage, meal breaks, and departure or return timings throughout the itinerary."
},
{
name: "20 Seater Traveller for One Day Trip Pune",
description: "20 Seater Traveller for One Day Trip Pune is designed for groups planning a same-day excursion to nearby destinations and attractions from Pune. The rental can be scheduled around the preferred departure and return times, allowing the group to manage sightseeing, meals, rest stops, and the complete round trip through one dedicated vehicle."
},
{
name: "20 Seater Traveller for Corporate Travel Pune",
description: "20 Seater Traveller for Corporate Travel Pune provides organized group transportation for employees, management teams, clients, and business groups traveling between offices, hotels, meeting venues, industrial locations, and event destinations. The vehicle can be coordinated around business schedules, pickup requirements, passenger count, and planned route details."
},
{
name: "20 Seater Traveller for Marriage Pune",
description: "20 Seater Traveller for Marriage Pune helps families organize transportation for marriage ceremonies, receptions, pre-wedding functions, and related guest movements. It can be useful for transfers between residences, hotels, venues, and outstation locations while keeping relatives and guests together through a planned transportation arrangement."
},
{
name: "20 Seater Luxury Traveller Hire Pune",
description: "20 Seater Luxury Traveller Hire Pune provides a premium group travel option for customers arranging special tours, weddings, corporate events, family celebrations, and extended journeys. The service is suitable when a medium-sized group wants to travel together while giving additional attention to cabin comfort and the overall travel experience."
},
{
name: "20 Seater AC Traveller Rental Pune",
description: "20 Seater AC Traveller Rental Pune offers air-conditioned group transportation for families, corporate teams, tourists, wedding groups, and other medium-sized parties. It can be arranged for local travel, airport transfers, one-day excursions, and long-distance journeys where maintaining a comfortable cabin environment is important for passengers."
},
{
name: "20 Seater Traveller for Tourist Trip Pune",
description: "20 Seater Traveller for Tourist Trip Pune is suitable for groups exploring hill stations, beaches, pilgrimage destinations, heritage locations, and other tourist circuits from Pune. A dedicated vehicle allows the group to follow one common itinerary while providing practical seating, luggage accommodation, and coordinated transportation between different sightseeing locations."
}
],
tableData: [
["20 Seater Tempo Traveller Rental Pune", "Dedicated 20-seater rental for family tours, group journeys, corporate programs, and special events."],
["20 Seater Tempo Traveller Hire Pune", "20-seater vehicle hire for medium-sized groups traveling together on planned routes."],
["20 Seater Tempo Traveller Booking Pune", "Advance booking support for passenger groups, destinations, travel dates, and complete itineraries."],
["20 Seater AC Tempo Traveller Pune", "Air-conditioned 20-seater option for comfortable local, outstation, and long-distance group travel."],
["20 Seater Luxury Tempo Traveller Pune", "Premium 20-seater transportation for special occasions, corporate travel, weddings, and extended tours."],
["20 Seater Traveller for Outstation Pune", "Dedicated medium-sized group vehicle for destinations outside Pune and longer road journeys."],
["20 Seater Traveller for Family Trip Pune", "Shared 20-seater transportation for families traveling together with luggage and personal belongings."],
["20 Seater Traveller for Group Travel Pune", "Practical group transportation for friends, relatives, social groups, and organized travel parties."],
["20 Seater Traveller for Corporate Events Pune", "Corporate group vehicle for conferences, meetings, employee events, outings, and company programs."],
["20 Seater Traveller for Wedding Pune", "20-seater transportation for wedding guests, relatives, functions, venue transfers, and ceremonies."],
["20 Seater Traveller for School Trip Pune", "Organized transportation for educational tours, excursions, student groups, and school outings."],
["20 Seater Traveller for Airport Pickup Pune", "Group airport pickup and transfer arrangement with seating and luggage accommodation."],
["Affordable 20 Seater Tempo Traveller Pune", "Budget-conscious 20-seater group transportation planned around destination and travel requirements."],
["20 Seater Traveller Rental Service Pune", "Flexible rental service for tours, events, sightseeing, family trips, and corporate travel."],
["20 Seater Traveller for Picnic Pune", "Shared transportation for family, office, college, and social picnic groups."],
["20 Seater Traveller for Local Sightseeing Pune", "20-seater vehicle support for multiple sightseeing stops within a planned travel itinerary."],
["20 Seater Traveller for One Day Trip Pune", "Same-day group travel option with coordinated departure, sightseeing, and return schedules."],
["20 Seater Traveller for Corporate Travel Pune", "Dedicated transportation for employees, management teams, clients, and business groups."],
["20 Seater Traveller for Marriage Pune", "Group vehicle arrangement for marriage functions, guest transfers, relatives, and venue travel."],
["20 Seater Luxury Traveller Hire Pune", "Premium 20-seater hire for weddings, corporate programs, special tours, and group occasions."],
["20 Seater AC Traveller Rental Pune", "Air-conditioned 20-seater rental for comfortable group transportation across different routes."],
["20 Seater Traveller for Tourist Trip Pune", "Dedicated 20-seater travel option for sightseeing tours and multi-destination tourist circuits."]
],
whychoose: [
{
WhyChooseheading: "Convenient 20-Seater Capacity",
WhyChoosedescription: "A 20-seater Tempo Traveller is suitable for medium-sized groups that need more capacity than a few cars but do not require a very large bus. The shared vehicle arrangement allows passengers to remain together while making route planning, luggage management, communication, and overall trip coordination easier."
},
{
WhyChooseheading: "Designed for Group Journeys",
WhyChoosedescription: "Family holidays, corporate outings, school trips, wedding functions, and tourist tours often involve several passengers traveling on the same schedule. A dedicated 20-seater provides one coordinated transportation solution, helping organizers manage the group from the initial pickup through the destination and return journey."
},
{
WhyChooseheading: "AC and Premium Options",
WhyChoosedescription: "Travel requirements can differ depending on the season, destination, occasion, and passenger expectations. Customers can consider AC or luxury 20-seater options when additional cabin comfort is preferred for longer highway journeys, corporate programs, wedding transportation, family vacations, or special group tours."
},
{
WhyChooseheading: "Suitable for Outstation Tours",
WhyChoosedescription: "Long-distance trips from Pune require transportation that can accommodate passengers, luggage, and a complete travel itinerary in one arrangement. A 20-seater Tempo Traveller can support multi-day journeys to hill stations, beaches, pilgrimage destinations, tourist locations, and other destinations across Maharashtra and nearby states."
},
{
WhyChooseheading: "Useful for Weddings and Events",
WhyChoosedescription: "Marriage functions, receptions, corporate events, and family celebrations often involve scheduled movement between multiple locations. A dedicated 20-seater can help transport guests and participants between homes, hotels, venues, and other destinations while maintaining a common travel schedule for the group."
},
{
WhyChooseheading: "Practical for Families and Friends",
WhyChoosedescription: "Traveling as one group can make family and friend trips easier to organize, especially when children, senior members, and multiple pieces of luggage are involved. A 20-seater provides a shared vehicle where passengers can travel together instead of managing several separate cars and coordinating different departure or arrival times."
},
{
WhyChooseheading: "Flexible Trip Planning",
WhyChoosedescription: "The rental can be planned around different types of itineraries, including one-day trips, weekend holidays, multi-day tours, sightseeing programs, airport transfers, and corporate travel. Pickup locations, destinations, travel duration, scheduled stops, and return requirements can be considered while arranging the group transportation."
},
{
WhyChooseheading: "Organized Travel Support",
WhyChoosedescription: "Ruturaj Enterprises handles 20-seater Tempo Traveller requirements for tourist trips, family journeys, school excursions, corporate programs, weddings, picnics, and outstation travel. The focus is on matching the vehicle arrangement with passenger needs, destination, schedule, luggage requirements, and the overall purpose of the trip."
}
]
};












const faqData = [
{
question: "How can I rent a 20 seater Tempo Traveller in Pune?",
answer: "A 20 seater Tempo Traveller can be arranged by sharing the pickup location, destination, travel date, passenger count, journey duration, and planned route. Ruturaj Enterprises can coordinate the vehicle for family vacations, group tours, corporate outings, weddings, pilgrimages, sightseeing programs, school trips, and other travel requirements from Pune."
},
{
question: "Who should consider a 20 seater Tempo Traveller in Pune?",
answer: "A 20 seater Tempo Traveller can be suitable for groups that are larger than a typical family car but do not require a full-size bus. Families, friends, corporate teams, wedding groups, educational groups, and tour parties can use this type of vehicle when they want to travel together on local or outstation journeys."
},
{
question: "Can a 20 seater Tempo Traveller be used for long-distance travel?",
answer: "Long-distance journeys from Pune can be planned with a 20 seater Tempo Traveller for destinations across Maharashtra and other states. Multi-day travel can include sightseeing stops, meal breaks, rest periods, overnight stays, and return journeys, allowing the group to follow one coordinated transportation plan throughout the tour."
},
{
question: "Is the 20 seater Tempo Traveller suitable for family tours?",
answer: "Families traveling as a medium-sized group can consider a 20 seater Tempo Traveller for vacations, weekend getaways, sightseeing tours, and multi-destination trips. A dedicated vehicle allows everyone to remain together while managing luggage, planned stops, accommodation transfers, and the overall travel schedule."
},
{
question: "Can I rent a 20 seater Tempo Traveller for a wedding?",
answer: "Wedding parties can use a 20 seater Tempo Traveller for guest transportation between homes, hotels, railway stations, airports, marriage halls, banquet venues, and reception locations. The vehicle schedule can be coordinated with ceremony timings and venue changes to help organizers manage guest movement during the function."
},
{
question: "Can corporate teams hire a 20 seater Tempo Traveller in Pune?",
answer: "Corporate groups can arrange a 20 seater Tempo Traveller for employee outings, team-building activities, conferences, training programs, business events, and company tours. The travel plan can include employee pickup points, destination details, event timings, planned stops, and return travel according to the organization's requirements."
},
{
question: "Is a 20 seater Tempo Traveller useful for pilgrimage tours?",
answer: "Pilgrimage groups can use a 20 seater Tempo Traveller for temple tours and religious journeys involving several destinations. The itinerary can be organized around darshan timings, temple visits, meal breaks, rest stops, sightseeing locations, and overnight halts, allowing the group to travel together throughout the pilgrimage."
},
{
question: "Can schools and colleges rent a 20 seater Tempo Traveller?",
answer: "Schools and colleges can consider a 20 seater Tempo Traveller for smaller educational groups, faculty travel, excursions, recreational trips, and study tours. Passenger numbers, accompanying staff, destination locations, planned stops, travel duration, and the complete educational itinerary can be considered while arranging the transportation."
},
{
question: "What information is required to book a 20 seater Tempo Traveller?",
answer: "For a rental request, it is helpful to provide the pickup location, destination, travel date, number of passengers, luggage requirements, trip duration, intermediate stops, and preferred schedule. A detailed itinerary is useful for multi-day journeys because Ruturaj Enterprises can coordinate the transportation around the complete route and planned activities."
},
{
question: "Why choose Ruturaj Enterprises for a 20 seater Tempo Traveller on rent in Pune?",
answer: "Ruturaj Enterprises arranges 20 seater Tempo Traveller transportation for family tours, corporate programs, weddings, pilgrimages, educational trips, sightseeing journeys, weekend outings, and outstation travel. The rental plan can be coordinated according to passenger strength, route, luggage, pickup points, journey duration, planned stops, and the group's overall itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Mahesh Bhosale",
feedback:
"We rented a 20 seater Tempo Traveller from Ruturaj Enterprises for a family tour from Pune. The seating capacity suited our group, and traveling together made it easier to manage our bags and multiple sightseeing stops. Having one dedicated vehicle also helped us maintain the same schedule throughout the trip.",
rating: 5
},
{
id: 2,
name: "Miss. Sonali Chavan",
feedback:
"Our group used a 20 seater Tempo Traveller for a pilgrimage journey starting from Pune. With several temple visits planned, having everyone in one vehicle made the route and timing easier to coordinate. Ruturaj Enterprises helped us arrange transportation around our planned stops and overall travel schedule.",
rating: 5
}
];































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "20 Seater Tempo Traveller On Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/20-seater-tempo-traveller-on-rent-in-pune.webp",
  "description":
    "20 Seater Tempo Traveller On Rent in Pune for family tours, group travel, corporate outings, weddings, school and college trips, picnics, sightseeing and outstation journeys. Ruturaj Enterprises provides 20 seater Tempo Traveller rental, hire and booking services with AC and luxury travel options for comfortable group transportation. Spacious seating, experienced drivers and flexible rental plans make the vehicle suitable for one-day trips, weekend getaways, multi-day tours, airport transfers and long-distance journeys from Pune to destinations across Maharashtra and other states.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/20-seater-tempo-traveller-on-rent-in-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>
    20 Seater Tempo Traveller On Rent in Pune | 20 Seater Tempo Traveller Hire Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="20 Seater Tempo Traveller On Rent in Pune for family trips, group tours, corporate events, weddings, school trips, picnics, sightseeing and outstation travel. Hire AC and luxury 20 seater Tempo Traveller from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="20 Seater Tempo Traveller Rental Pune, 20 Seater Tempo Traveller Hire Pune, 20 Seater Tempo Traveller Booking Pune, 20 Seater AC Tempo Traveller Pune, 20 Seater Luxury Tempo Traveller Pune, 20 Seater Traveller for Outstation Pune, 20 Seater Traveller for Family Trip Pune, 20 Seater Traveller for Group Travel Pune, 20 Seater Traveller for Corporate Events Pune, 20 Seater Traveller for Wedding Pune, 20 Seater Traveller for School Trip Pune, 20 Seater Traveller for Picnic Pune, 20 Seater Traveller for Airport Pickup Pune, Affordable 20 Seater Tempo Traveller Pune, 20 Seater Tempo Traveller On Rent Pune, 20 Seater Tempo Traveller on Rent in Pune, 20 Seater Tempo Traveller Rental Service Pune, 20 Seater Tempo Traveller Hire Service Pune, 20 Seater Tempo Traveller Booking Service Pune, 20 Seater AC Traveller Pune, 20 Seater AC Tempo Traveller on Rent Pune, 20 Seater AC Tempo Traveller Hire Pune, 20 Seater AC Tempo Traveller Booking Pune, 20 Seater Luxury Traveller Pune, 20 Seater Luxury Tempo Traveller on Rent Pune, 20 Seater Luxury Tempo Traveller Hire Pune, 20 Seater Luxury Tempo Traveller Booking Pune, 20 Seater Tourist Tempo Traveller Pune, 20 Seater Tourist Traveller Rental Pune, 20 Seater Tourist Traveller Hire Pune, 20 Seater Tourist Traveller Booking Pune, 20 Seater Outstation Tempo Traveller Pune, 20 Seater Outstation Tempo Traveller Rental Pune, 20 Seater Outstation Tempo Traveller Hire Pune, 20 Seater Outstation Tempo Traveller Booking Pune, 20 Seater One Way Tempo Traveller Pune, 20 Seater One Way Tempo Traveller Rental Pune, 20 Seater One Way Tempo Traveller Hire Pune, 20 Seater Round Trip Tempo Traveller Pune, 20 Seater Round Trip Tempo Traveller Rental Pune, 20 Seater Round Trip Tempo Traveller Hire Pune, 20 Seater Local Tempo Traveller Pune, 20 Seater Local Tempo Traveller Rental Pune, 20 Seater Local Tempo Traveller Hire Pune, 20 Seater Local Tempo Traveller Booking Pune, 20 Seater Family Tempo Traveller Pune, 20 Seater Family Tour Tempo Traveller Pune, 20 Seater Family Travel Tempo Traveller Pune, 20 Seater Group Tempo Traveller Pune, 20 Seater Group Tour Tempo Traveller Pune, 20 Seater Group Travel Tempo Traveller Pune, 20 Seater Corporate Tempo Traveller Pune, 20 Seater Corporate Tempo Traveller Rental Pune, 20 Seater Corporate Tempo Traveller Hire Pune, 20 Seater Corporate Tempo Traveller Booking Pune, 20 Seater Corporate Travel Tempo Traveller Pune, 20 Seater Corporate Event Tempo Traveller Pune, 20 Seater Event Tempo Traveller Pune, 20 Seater Event Rental Traveller Pune, 20 Seater Event Hire Traveller Pune, 20 Seater Wedding Tempo Traveller Pune, 20 Seater Wedding Tempo Traveller Rental Pune, 20 Seater Wedding Tempo Traveller Hire Pune, 20 Seater Wedding Tempo Traveller Booking Pune, 20 Seater Wedding Guest Traveller Pune, 20 Seater Wedding Guest Transportation Pune, 20 Seater Marriage Tempo Traveller Pune, 20 Seater Marriage Traveller Rental Pune, 20 Seater Marriage Traveller Hire Pune, 20 Seater School Tempo Traveller Pune, 20 Seater School Trip Traveller Pune, 20 Seater School Tour Traveller Pune, 20 Seater College Trip Traveller Pune, 20 Seater Picnic Tempo Traveller Pune, 20 Seater Picnic Traveller Rental Pune, 20 Seater Picnic Traveller Hire Pune, 20 Seater Family Picnic Traveller Pune, 20 Seater Group Picnic Traveller Pune, 20 Seater Airport Tempo Traveller Pune, 20 Seater Airport Transfer Traveller Pune, 20 Seater Airport Pickup Traveller Pune, 20 Seater Airport Drop Traveller Pune, 20 Seater Sightseeing Tempo Traveller Pune, 20 Seater Sightseeing Traveller Rental Pune, 20 Seater Sightseeing Traveller Hire Pune, 20 Seater Pune City Tour Traveller, 20 Seater Traveller for Maharashtra Tour Pune, 20 Seater Traveller for Weekend Trip Pune, 20 Seater Traveller for Holiday Trip Pune, 20 Seater Traveller for Temple Tour Pune, 20 Seater Pilgrimage Traveller Pune, 20 Seater Traveller for Tourist Pune, 20 Seater Tempo Traveller with Driver Pune, 20 Seater Tempo Traveller Rental with Driver Pune, 20 Seater Tempo Traveller Hire with Driver Pune, 20 Seater Tempo Traveller Booking with Driver Pune, Comfortable 20 Seater Tempo Traveller Pune, Premium 20 Seater Tempo Traveller Pune, Professional 20 Seater Tempo Traveller Rental Pune, Reliable 20 Seater Tempo Traveller Hire Pune, 20 Seater Group Transportation Pune, 20 Seater Traveller Transportation Pune, 20 Seater Tempo Traveller Service Pune, 20 Seater Tempo Traveller Rental Near Me Pune, 20 Seater Tempo Traveller Hire Near Me Pune, Ruturaj Enterprises 20 Seater Tempo Traveller Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Twozeroseatertempo;